"use client"

import {
  createContext,
  type ReactNode,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react"

type VideoContextValue = {
  activeVideoId: string | null
  playVideo: (id: string) => void
  stopVideo: (id: string) => void
}

const VideoContext = createContext<VideoContextValue | null>(null)

export const VideoProvider = ({ children }: { children: ReactNode }) => {
  const [activeVideoId, setActiveVideoId] = useState<string | null>(null)

  const playVideo = useCallback((id: string) => {
    setActiveVideoId(id)
  }, [])

  const stopVideo = useCallback((id: string) => {
    setActiveVideoId((current) => (current === id ? null : current))
  }, [])

  const value = useMemo(
    () => ({ activeVideoId, playVideo, stopVideo }),
    [activeVideoId, playVideo, stopVideo],
  )

  return <VideoContext.Provider value={value}>{children}</VideoContext.Provider>
}

export const useVideoContext = () => {
  const context = useContext(VideoContext)
  if (!context) {
    throw new Error("useVideoContext must be used within a VideoProvider")
  }
  return context
}
